import { Configuration } from './configuration.model';
import DeviceType from './device.type';
import { defaultHours } from './WorkingHours';

const translations = {
  bubbleStyle: {
    en: {
      theme: 'green',
      header: true,
      thanksTitle: 'Thanks, we will call you immediately!',
      description:
        'Would you like to receive a free call back right now? Leave us your phone number and we’ll contact you immediately',
      fontStyle: 'Roboto',
      fontSize: '16px',
      phoneNumberLabel: 'Phone number',
      title: 'Call us for free',
      errorMessage: 'Not valid phone number',
      submitButtonTextBig: 'Call Us',
      closeButtonEnabled: false,
      callUsText: 'Call us',
      hangupButtonText: 'Hangup'
    },
    es: {
      theme: 'green',
      header: true,
      thanksTitle: 'Gracias, te llamaremos inmediatamente!',
      description:
        '¿Quieres recibir una llamada ahora mismo? Deja tu número de teléfono y te llamaremos inmediatamente',
      fontStyle: 'Roboto',
      fontSize: '16px',
      phoneNumberLabel: 'Núemro de teléfono',
      title: 'Pedir llamada',
      errorMessage: 'Mensaje de error',
      submitButtonTextBig: 'Llámame ahora',
      closeButtonEnabled: false,
      callUsText: 'Call us',
      hangupButtonText: 'Colgar'
    }
  },
  popupStyle: {
    en: {
      title: 'Would you like to receive a free call back right now?',
      description: 'Enter your phone number:',
      buttonText: 'Yes',
      thanksTitle: 'Thanks, we will call you immediately!',
      thanksText: 'We will call you as soon as possible',
      errorMessage: 'Not valid phone number',
      fontSize: '32px',
      fontStyle: 'Roboto',
      theme: 'green',
      advanced: false
    },
    es: {
      title: '¿Quieres recibir una llamada ahora mismo?',
      description: 'Escribe tu número de teléfono:',
      buttonText: 'Sí',
      thanksTitle: 'Gracias, te llamaremos inmediatamente!',
      thanksText: 'Te llamaremos lo más pronto posible',
      errorMessage: 'Número de teléfono no válido',
      fontSize: '32px',
      fontStyle: 'Roboto',
      theme: 'green',
      advanced: false
    }
  }
};

export const initialConfig = (appId: string, lang: string): Configuration => ({
  appId,
  projectId: null,
  channelsAccount: appId,
  domainName: '',
  allowSubdomains: false,
  bubbleStyle: translations.bubbleStyle[lang],
  popupStyle: translations.popupStyle[lang],
  name: 'Web Call',
  webhookUrl: '',
  active: true,
  displayOnDeviceType: DeviceType.ALL,
  displayConditionsEnabled: false,
  displayConditions: [],
  timeBetweenSubmittedPopups: 1440,
  ignoreDisplayLimit: false,
  timeBetweenShownPopups: 60,
  activeType: '',
  displayConditionsLogicalOperator: 'and',
  afterClickMode: 'WEB_CALL',
  workingHours: {
    enabled: false,
    ranges: [
      {
        hours: [defaultHours],
        days: [1, 2, 3, 4, 5, 6, 7]
      }
    ]
  }
});
